import React, { useEffect, useState } from 'react';
import { Divider } from '@material-ui/core';
import { useLocation } from 'react-router-dom';
import { connect } from 'react-redux';
import {
  CommonPagination,
  ScreenContainer,
} from '../../CommonComponents';
import {
  getAllSites, getFilters,
} from '../../redux/actions/sites';
import SiteAssignTable from './SiteAssignTable'
import FallbackCard from '../../CommonComponents/FallbackCard';
import ClientPrimaryFilters from '../../CommonComponents/ClientPrimaryFilters';
import { atrFetchReport, getSitesByEstimateNo } from '../../redux/actions/common';
import ClientSitesFilter from '../../CommonComponents/SitesFilter/ClientSitesFilter';

function useQuery() {
  return new URLSearchParams(useLocation().search);
}

const AuditorSiteAssign = ({
  getAllSitesAction, totalSitePages, primaryQuery, searchQuery,
  fetchSites, getFilter, fetchReport,
}) => {
  const query = useQuery();
  const page = parseInt(query.get('page') || '1', 10);
  const [showSites, enableSites] = useState(false);
  const [campaignNo, setCampaignNo] = useState()
  const { pathname } = useLocation();

  useEffect(() => {
    const pno = query.get('page')
    if (showSites && pno) getAllSitesAction(page, searchQuery, primaryQuery);
  }, [query, getAllSitesAction, getFilter, searchQuery, primaryQuery, showSites, page]);

  const fetchAllSite = (val) => {
    setCampaignNo(val)
    fetchSites({ estimateNo: val });
    enableSites(true);
  }

  const handleFilter = (status) => {
    fetchSites({ estimateNo: campaignNo, status });
  }

  const fetchReports = (val) => {
    setCampaignNo(val)
    fetchReport({ campaignNo: val })
  }

  useEffect(() => {
    enableSites(false);
  }, [pathname])

  return (
    <ScreenContainer title={pathname === '/reported-sites' ? 'Reported Sites' : 'Activity Tracking Report'}>
      {pathname === '/reported-sites'
        ? (
          <ClientPrimaryFilters
            visibleProduct
            visibleEstimate
            fetchFunction={fetchAllSite}
            location="siteRapportAuditor"
            showFetchButton
          />
        ) : (
          <ClientPrimaryFilters
            visibleProduct
            visibleEstimate
            fetchFunction={fetchReports}
            location="atrReport"
            showFetchButton={false}
          />
        )}
      <br />
      {showSites
        ? (
          <>
            <ClientSitesFilter currentLocation="reported-sites" campaignNo={campaignNo} />
            <div className="row">
              <Divider />
              <div className="col-12">
                <br />
                <SiteAssignTable handleFilter={handleFilter} />
                {totalSitePages > 1 ? (
                  <CommonPagination
                    baseUrl="reported-sites"
                    totalPages={totalSitePages}
                  />
                ) : null}
                <br />
              </div>
            </div>
          </>
        )
        : <FallbackCard text="Fetch the sites to start" />}
    </ScreenContainer>
  );
};

const mapState = (state) => ({
  totalSitePages: state.sites.totalSitePages,
  searchQuery: state.sites.searchQuery,
  primaryQuery: state.sites.primaryQuery,
});

const mapActions = {
  getAllSitesAction: getAllSites,
  fetchSites: getSitesByEstimateNo,
  fetchReport: atrFetchReport,
  getFilter: getFilters,

};

export default connect(mapState, mapActions)(AuditorSiteAssign);
